import { useEffect, useState } from 'react'

import {
  DSCircularLoading,
  DSCol,
  DSDivider,
  DSIcon,
  DSModal,
  DSRow,
  DSText
} from '@vr/ds-react'

import { IModalDetailsProps } from './interface'
import { BoxContent, BoxHeader, ContentCol } from './styled'
import EditableText from '../editable-text'
import { useUnitGet } from '@/hooks/use-unit-get'
import { formatCurrency } from '@/utils/format-currency'
import { formatDateToBR } from '@/utils/format-date-to-br'

const ModalDetails = ({
  unitId,
  isEditable,
  onClose = () => { },
  setShowErrorModal
}: IModalDetailsProps) => {
  const { unitGet } = useUnitGet()
  const [result, setResult] = useState<any>(null)

  useEffect(() => {
    const fetchData = async () => {
      const res = await unitGet(unitId)
      setResult(res)

      if (!res) {
        onClose()
        setShowErrorModal(true)
      }
    }
    fetchData()
  }, [unitId])

  return (
    <DSModal config={{ show: true, onClose }} css={{ width: '80%' }}>
      <DSModal.Header onClose={onClose}>Detalhes do item</DSModal.Header>
      <DSModal.Body>
        {(() => {
          if (result === null) {
            return <DSCircularLoading isLoading shouldBlur={false} />
          }
          if (result) {
            return (
              <>
                <BoxHeader>
                  <DSRow wrap='wrap'>
                    <ContentCol sm={12} lg={4}>
                      <DSText as='p' weight='semibold'>
                        Operadora
                      </DSText>
                      <DSText as='p' weight='bold'>
                        {result?.nomeOperadora} {result?.cnpjOperadora}
                      </DSText>
                    </ContentCol>
                    <ContentCol sm={12} lg={3}>
                      <DSText as='p' weight='semibold'>
                        Endereço de coleta
                      </DSText>
                      <DSText as='p' weight='bold'>
                        {result?.endereco}
                      </DSText>
                    </ContentCol>
                    <ContentCol sm={12} lg={3}>
                      <DSText as='p' weight='semibold'>
                        Num. ped. na operadora
                      </DSText>
                      <DSText as='p' weight='bold'>
                        {result?.pedidoNaOperadora}
                      </DSText>
                    </ContentCol>
                    <ContentCol sm={12} lg={2}>
                      <DSText as='p' weight='semibold'>
                        Data da liberação
                      </DSText>
                      <DSText as='p' weight='bold'>
                        {formatDateToBR(new Date(result?.dataLiberacao))}
                      </DSText>
                    </ContentCol>
                  </DSRow>
                </BoxHeader>
                <DSRow wrap='wrap' css={{ marginTop: '16px' }}>
                  <DSCol sm={12} lg={8} css={{ paddingLeft: '0' }}>
                    <BoxContent>
                      <DSText as='p' weight='medium' size='sm'>
                        <DSText as='p' weight='bold'>
                          Fornecedor:
                        </DSText>{' '}
                        {result?.nomeFornecedor}
                      </DSText>
                      <DSText as='p' weight='medium' size='sm'>
                        <DSText as='p' weight='bold'>
                          Taxa de retirada:
                        </DSText>{' '}
                        {formatCurrency(result?.taxaDeRetirada)}
                      </DSText>

                      <DSDivider css={{ margin: '16px 0' }} />

                      <DSText as='p' weight='medium' size='sm'>
                        <DSText as='p' weight='bold'>
                          Grupo econômico:
                        </DSText>{' '}
                        {result?.nomeEmpregador} - {result?.cnpjEmpregador}
                      </DSText>
                      <DSText as='p' weight='medium' size='sm'>
                        <DSText as='p' weight='bold'>
                          Unidade:
                        </DSText>{' '}
                        {result?.nomeUnidade} - {result?.cnpjUnidade}
                      </DSText>

                      <DSDivider css={{ margin: '16px 0' }} />

                      <DSText as='p' weight='medium' size='sm'>
                        <DSText as='p' weight='bold'>
                          Colaborador:
                        </DSText>{' '}
                        {result?.nome}
                      </DSText>
                      <DSText
                        as='p'
                        weight='medium'
                        size='sm'
                        style={{
                          display: 'flex',
                          gap: 3,
                          alignItems: 'center'
                        }}
                      >
                        <DSText as='p' weight='bold'>
                          Num. do cartão:
                        </DSText>
                        {isEditable ? (
                          <EditableText
                            unit={result}
                            collectId={result.idAgrupamento}
                          />
                        ) : (
                          result?.numeroCartao
                        )}
                      </DSText>
                    </BoxContent>
                  </DSCol>
                  <DSCol sm={12} lg={4} css={{ paddingRight: '0' }}>
                    {result?.historicos ? (
                      result?.historicos?.map((item: any) => (
                        <BoxContent
                          key={item?.id}
                          css={{
                            borderColor:
                              item?.titulo === 'pendente'
                                ? '$primaryDefault'
                                : '$neutralMedium',
                            opacity: item?.titulo ? 1 : 0.5
                          }}
                        >
                          <DSText weight='bold' size='md'>
                            {item?.titulo}
                          </DSText>
                          {item?.data && (
                            <>
                              <DSText weight='regular' size='sm'>
                                <DSIcon
                                  name='principal-calendar'
                                  customSize={20}
                                />{' '}
                                em {formatDateToBR(new Date(item?.data))}
                              </DSText>
                              {item?.responsavel && (
                                <DSText weight='regular' size='sm'>
                                  <DSIcon name='user-simple' customSize={20} />{' '}
                                  por {item?.responsavel}
                                </DSText>
                              )}
                              <DSText weight='regular' size='sm'>
                                {item?.descricao}
                              </DSText>
                            </>
                          )}

                          {item?.titulo === 'pendente' && (
                            <DSText as='p' weight='regular' size='sm'>
                              <DSIcon name='principal-clock' customSize={20} />{' '}
                              {item?.titulo}
                            </DSText>
                          )}
                        </BoxContent>
                      ))
                    ) : (
                      <BoxContent
                        css={{
                          borderColor: '$neutralMedium',
                          opacity: 0.5
                        }}
                      >
                        <DSText weight='regular' size='md'>
                          Sem movimentações
                        </DSText>
                      </BoxContent>
                    )}
                  </DSCol>
                </DSRow>
              </>
            )
          }
        })()}
      </DSModal.Body>
      <DSModal.Footer></DSModal.Footer>
    </DSModal>
  )
}

export default ModalDetails
